import React from "react";
import Fonts from "../../../../stories/assets/Fonts";
import Colors from "../../../../stories/assets/Colors";
import ModalSkeleton from "../../../ModalSkeleton/ModalSkeleton";
import { Button } from "../../../../stories/Button/Button";
import { Modal } from "react-bootstrap";
import classes from "./MessageExplanationModal.module.css";
import { starIconss } from "../../../../constant/imagePath";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";

const MessageExplanationModal = ({ show, setShow, title, data }) => {
  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        borderRadius={"20px"}
        width={"509px"}
        showCloseIcon={true}
        footer={
          <div className={classes.modalButtons}>
            <LinkButtonWithIcon
              primary={false}
              text="Cancel"
              customStyle={{ color: Colors.neutralShadesOfNero, marginRight: '48px' }}
            />
            <Button
              size="Medium"
              primary={true}
              label="Send"
              style={{
                width: "max-content",
                padding: '14px 42.5px'

              }}
            />
          </div>

        }
      >
        <div className={classes.modalContent}>
          <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
            {title}
          </h4>
          <h4 style={{ ...Fonts.h4, color: Colors.neutralShadesOfNero }}>
            explaination: {data?.userData?.user}
          </h4>

          <div className={classes.wrapperTextarea}>
            <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
              Explaination
            </p>
            <textarea
              name="modal"
              className={classes.custumTextArea}
            ></textarea>
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default MessageExplanationModal;

MessageExplanationModal.defaultProps = {
  data: {
    userData: {
      user: "John Johnson",
    },
  },
};
